import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImgOne from "../../images/services-usa/social-media/power_media_market.webp";
import BgImgTwo from "../../images/services-usa/social-media/power_media_2.webp";
import BgImgThree from "../../images/services-usa/social-media/power_media_3.webp";
import BgImgFour from "../../images/services-usa/social-media/power_media_4.webp";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";

function NextGen({ handleShow }) {
  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);
  return (
    <section className="tekrevol__nextgen p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mb-3 mb-md-4 text-center"
          >
            <h2>
              The Power of <span>Social Media</span>
            </h2>
          </Col>

          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              // navigation={{
              // prevEl: prevRef?.current,
              // nextEl: nextRef?.current,
              // }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{ clickable: true }}
              onSwiper={setSwiper}
              onSlideChange={() => console.log("slide change")}
              className="carosal_nextgen"
            >
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgOne})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Market Growth
                      {/* <br className="d-lg-block d-none" /> Strategy for{" "}
                      <span>Gen AI</span> */}
                    </h3>
                    <p>
                      As of 2023, the global social media marketing market was
                      valued at approximately{" "}
                      <strong style={{ color: "#f47a14" }}>
                        $16.6 billion
                      </strong>{" "}
                      and is expected to nearly double and reach around{" "}
                      <strong style={{ color: "#f47a14" }}>$37.9</strong>
                      <strong style={{ color: "#f47a14" }}>
                        {" "}
                        billion by the year 2028.
                      </strong>
                    </p>
                    {/* <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link> */}
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgTwo})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Popular Social Media Platforms
                      {/* <br className="d-lg-block d-none" />{" "}
                      <span>Fingertips</span> */}
                    </h3>
                    <p>
                      Facebook, Instagram, LinkedIn, and TikTok are the top
                      platforms for offering worthwhile social media marketing
                      solutions:
                    </p>
                    <ul>
                      <li>
                        <strong>Facebook</strong> has about{" "}
                        <strong style={{ color: "#f47a14" }}>2.96</strong>{" "}
                        billion monthly active users
                      </li>
                      <li>
                        <strong>TikTok</strong> has{" "}
                        <strong style={{ color: "#f47a14" }}>1 billion</strong>{" "}
                        active users.
                      </li>
                      <li>
                        <strong>LinkedIn</strong> is known to serve
                        approximately{" "}
                        <strong style={{ color: "#f47a14" }}>
                          900 million
                        </strong>{" "}
                        professionals worldwide.
                      </li>
                      <li>
                        <strong>Instagram</strong> has around{" "}
                        <strong style={{ color: "#f47a14" }}>2 billion</strong>{" "}
                        active users.
                      </li>
                    </ul>
                    {/* <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link> */}
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgThree})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">Ad Spending</h3>
                    <p>
                      In the year 2023, global social media ad spending reached
                      around{" "}
                      <strong style={{ color: "#f47a14" }}>$213 billion</strong>{" "}
                      which is anticipated to grow as much as 25% annually.
                    </p>
                    {/* <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link> */}
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgFour})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">ROI</h3>
                    <p>
                      Businesses that are actively making investments in social
                      media marketing see an average return on investment (ROI)
                      of approximately{" "}
                      <strong style={{ color: "#f47a14" }}>30%</strong>.
                    </p>
                    {/* <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link> */}
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NextGen;
